import { PRODUCT_TAG_SEARCH } from './action_types';

const search = payload => ({
  type: PRODUCT_TAG_SEARCH,
  payload: payload
});

export { search };
